module.exports = __webpack_public_path__ + "static/media/default-centre-cover.cf22a5fc.png";